import * as tslib_1 from "tslib";
import * as lazyTriageActions from 'owa-mail-triage-action';
import * as React from 'react';
import getBackgroundColorClass from '../selectors/getBackgroundColorClass';
import getIsChecked from '../selectors/getIsChecked';
import IconBar from './shared/IconBar';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import strings from 'owa-strings/owa-mail-strings';
import { computed } from 'mobx';
import { getHoverSurfaceAction, getStore as getHoverSurfaceActionStore, } from 'owa-surface-actions-option';
import { getIconClassName } from '@uifabric/styling/lib/index';
import { getMailMenuItemShouldShowMap } from 'owa-mail-filterable-menu-behavior';
import { getMoveToPropertiesForContextMenu } from 'owa-mail-movetofolder-view';
import { getPropertyIconStyle, PropertyIcons } from 'owa-mail-list-actions';
import { hideMailItemContextMenu } from 'owa-mail-list-actions/lib/actions/itemContextMenuActions';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { lazyToggleRowReadState } from 'owa-mail-mark-read-actions';
import { observer } from 'mobx-react';
import { resetFocus } from 'owa-mail-focus-manager';
import { doesUserHaveSharedFolderPermissionFor, } from 'owa-mail-filterable-menu-behavior';
import { isFolderOfTreeType, SHARED_FOLDERS_TREE_TYPE } from 'owa-folders';
import { getFolderIdFromTableView } from 'owa-mail-search';
// Remark: We have to share css file with MailListItem since we need to trigger child hover selectors
// off of the MailListItem container css class
var styles = require('./MailListItem.scss');
var classNames = require('classnames/bind').bind(styles);
/*
Renders the mail list icon bar for both action icons and property icons
*/
var MailListItemIconBar = /** @class */ (function (_super) {
    tslib_1.__extends(MailListItemIconBar, _super);
    function MailListItemIconBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.deleteRow = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, lazyTriageActions.lazyDeleteMailListRows.importAndExecute([this.props.mailListItemDataProps.rowKey], this.props.mailListTableProps.tableViewId, false /*isExplicitSoftDelete*/, 'IconLV')];
                    case 1:
                        _a.sent();
                        // Reset focus after the lazy action is complete, to ensure that focus is set
                        // after any confirm dialogs are dismissed and the stitch has been raised
                        resetFocus();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.archiveRow = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, lazyTriageActions.lazyArchiveMailListRows.importAndExecute([this.props.mailListItemDataProps.rowKey], listViewStore.tableViews.get(this.props.mailListTableProps.tableViewId), 'IconLV')];
                    case 1:
                        _a.sent();
                        // Reset focus after the lazy action is complete, to ensure that focus is set
                        // after any confirm dialogs are dismissed and the stitch has been raised
                        resetFocus();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onDismissMoveToMenu = function (ev) {
            hideMailItemContextMenu();
            resetFocus();
        };
        _this.toggleMarkAsReadRow = function () {
            lazyToggleRowReadState.importAndExecute(_this.props.mailListItemDataProps.rowKey, _this.props.mailListTableProps.tableViewId, 'IconLV');
            // Reset focus after the stitch to mark the item as read is raised
            resetFocus();
        };
        _this.togglePinnedStateRow = function () {
            lazyTriageActions.lazyToggleRowPinnedState.importAndExecute(_this.props.mailListItemDataProps.rowKey, _this.props.mailListTableProps.tableViewId, 'IconLV');
            // Reset focus after the stitch to pin the item is raised
            resetFocus();
        };
        _this.toggleFlaggedStateRow = function () {
            lazyTriageActions.lazyToggleRowsFlagState.importAndExecute([_this.props.mailListItemDataProps.rowKey], _this.props.mailListTableProps.tableViewId, 'IconLV');
            // Reset focus after the stitch to flag the item is raised
            resetFocus();
        };
        return _this;
    }
    Object.defineProperty(MailListItemIconBar.prototype, "isChecked", {
        get: function () {
            var tableView = listViewStore.tableViews.get(this.props.mailListTableProps.tableViewId);
            return getIsChecked(tableView, this.props.mailListItemDataProps.rowKey, this.props.mailListItemDataProps.lastDeliveryTimestamp);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailListItemIconBar.prototype, "showHoverActions", {
        get: function () {
            var tableView = listViewStore.tableViews.get(this.props.mailListTableProps.tableViewId);
            if (!tableView) {
                return false;
            }
            return (this.props.supportsHoverIcons &&
                ((tableView.selectedRowKeys.size == 1 && tableView.isInCheckedMode) ||
                    (tableView.selectedRowKeys.size <= 1 && !tableView.isInVirtualSelectAllMode)));
        },
        enumerable: true,
        configurable: true
    });
    MailListItemIconBar.prototype.getHoverActionIcons = function () {
        var _this = this;
        var hoverActions = [];
        var mailListItemDataProps = this.props.mailListItemDataProps;
        var mailListTableProps = this.props.mailListTableProps;
        var hoverActionKeys = getHoverSurfaceActionStore().hoverSurfaceActions;
        // If no values exist in the store OR we have disabled customHoverActions.
        // Read values from owa userConfig.
        if (hoverActionKeys === null || !isControlFeatureEnabled('tri-customHoverActions')) {
            hoverActionKeys = getHoverSurfaceAction();
        }
        hoverActionKeys.forEach(function (action) {
            switch (action) {
                case 'Archive':
                    hoverActions[0] = {
                        title: strings.archive,
                        key: 'archiveIcon',
                        iconProps: {
                            className: classNames(getIconClassName("Archive" /* Archive */)),
                        },
                        onClickCommand: _this.archiveRow,
                    };
                    break;
                case 'Move':
                    hoverActions[1] = {
                        title: strings.moveTo,
                        key: 'moveIcon',
                        iconProps: {
                            className: getIconClassName("FabricMovetoFolder" /* FabricMovetoFolder */),
                        },
                        menuProps: _this.moveRow(),
                    };
                    break;
                case 'Delete':
                    if (mailListItemDataProps.canDelete &&
                        doesUserHaveSharedFolderPermissionFor(6 /* Delete */) /* Shared folder permission check */) {
                        hoverActions[2] = {
                            title: strings.deleteItem,
                            key: 'deleteIcon',
                            iconProps: {
                                className: getIconClassName("Delete" /* Delete */),
                            },
                            onClickCommand: _this.deleteRow,
                        };
                    }
                    break;
                case 'ReadUnread':
                    var hasUnread = mailListItemDataProps.unreadCount > 0;
                    hoverActions[3] = {
                        title: hasUnread ? strings.markAsRead : strings.markAsUnread,
                        key: 'markReadIcon',
                        iconProps: {
                            className: getIconClassName(hasUnread ? "Mail" /* Mail */ : "Read" /* Read */),
                        },
                        onClickCommand: _this.toggleMarkAsReadRow,
                    };
                    break;
                case 'FlagUnflag':
                    if (mailListTableProps.supportsFlagging &&
                        doesUserHaveSharedFolderPermissionFor(8 /* Flag */) /* Shared folder permission check */) {
                        var flagClasses = classNames(mailListItemDataProps.isFlagged && styles.flagIcon, getIconClassName("Flag" /* Flag */));
                        hoverActions[4] = {
                            title: mailListItemDataProps.isFlagged
                                ? strings.unflagTitle
                                : strings.flagTitle,
                            key: 'flagIcon',
                            iconProps: {
                                className: flagClasses,
                            },
                            onClickCommand: _this.toggleFlaggedStateRow,
                        };
                    }
                    break;
                case 'PinUnpin':
                    if (mailListTableProps.supportsPinning &&
                        doesUserHaveSharedFolderPermissionFor(22 /* Pin */) /* Shared folder permission check */) {
                        var pinClasses = classNames(mailListItemDataProps.isPinned
                            ? [styles.pinIcon, getIconClassName("Pinned" /* Pinned */)]
                            : getIconClassName("Pin" /* Pin */));
                        hoverActions[5] = {
                            title: mailListItemDataProps.isPinned
                                ? strings.unpin
                                : strings.pinTitle,
                            key: 'pinIcon',
                            iconProps: {
                                className: pinClasses,
                            },
                            onClickCommand: _this.togglePinnedStateRow,
                        };
                    }
                    break;
                case 'None':
                    break;
            }
        });
        return hoverActions;
    };
    MailListItemIconBar.prototype.getPropertyIconProps = function () {
        var mailListItemDataProps = this.props.mailListItemDataProps;
        var mailListTableProps = this.props.mailListTableProps;
        var propertyIconProps = [];
        var tableView = listViewStore.tableViews.get(mailListTableProps.tableViewId);
        // Build the property icon list from left to right
        // Item class icon first (meeting, note, etc.)
        if (mailListItemDataProps.itemClassIcon &&
            mailListItemDataProps.itemClassIcon !== PropertyIcons.None) {
            propertyIconProps.push({
                key: mailListItemDataProps.itemClassIcon.toString(),
                iconClasses: getPropertyIconStyle(mailListItemDataProps.itemClassIcon),
            });
        }
        // Importance icon
        if (mailListItemDataProps.importance == 'Low') {
            propertyIconProps.push({
                key: PropertyIcons.ImportanceLow.toString(),
                iconClasses: getPropertyIconStyle(PropertyIcons.ImportanceLow),
            });
        }
        else if (mailListItemDataProps.importance == 'High') {
            propertyIconProps.push({
                key: PropertyIcons.ImportanceHigh.toString(),
                iconClasses: getPropertyIconStyle(PropertyIcons.ImportanceHigh),
            });
        }
        // Attachment icon
        if (mailListItemDataProps.hasAttachment) {
            propertyIconProps.push({
                key: PropertyIcons.Attachment.toString(),
                iconClasses: getPropertyIconStyle(PropertyIcons.Attachment),
            });
        }
        // At mention icon
        if (isMailFeatureEnabled('cmp-mentions') && mailListItemDataProps.effectiveMentioned) {
            propertyIconProps.push({
                key: PropertyIcons.GlobalMentionedMe.toString(),
                iconClasses: getPropertyIconStyle(PropertyIcons.GlobalMentionedMe),
            });
        }
        // If the conversation/item has like count greater than 0, then show the LikeIcon
        if (isMailFeatureEnabled('rp-like') &&
            !isConsumer() &&
            !isFolderOfTreeType(getFolderIdFromTableView(tableView), SHARED_FOLDERS_TREE_TYPE) &&
            mailListItemDataProps.likeCount > 0) {
            propertyIconProps.push({
                key: PropertyIcons.Like.toString(),
                iconClasses: getPropertyIconStyle(PropertyIcons.Like),
            });
        }
        // If the conversation/item has been snoozed, then show the clock icon
        if (isMailFeatureEnabled('tri-snooze') && mailListItemDataProps.isSnoozed) {
            var snoozeClasses = classNames(getPropertyIconStyle(PropertyIcons.Snooze));
            propertyIconProps.push({
                key: PropertyIcons.Snooze.toString(),
                iconClasses: snoozeClasses,
            });
        }
        // Flag icon
        if (mailListTableProps.supportsFlagging &&
            mailListItemDataProps.isFlagged &&
            doesUserHaveSharedFolderPermissionFor(8 /* Flag */) /* Shared folder permission check */) {
            var flagIconClasses = classNames(styles.flagIcon, getIconClassName("Flag" /* Flag */));
            propertyIconProps.push({
                key: 'flagIcon',
                iconClasses: flagIconClasses,
            });
        }
        // Pin icon if pinned
        // Add flag icon as the right most icon if pinning is not supported
        // If pinning is supported we leave a place for pin hover action/property icon
        if (mailListTableProps.supportsPinning &&
            (mailListItemDataProps.isPinned || mailListItemDataProps.isFlagged) &&
            doesUserHaveSharedFolderPermissionFor(22 /* Pin */) /* Shared folder permission check */) {
            var pinIconClasses = classNames(styles.pinIcon, getIconClassName("Pinned" /* Pinned */), mailListItemDataProps.isFlagged &&
                !mailListItemDataProps.isPinned &&
                'visibilityHidden');
            propertyIconProps.push({
                key: 'pinIcon',
                iconClasses: pinIconClasses,
            });
        }
        return propertyIconProps;
    };
    MailListItemIconBar.prototype.moveRow = function () {
        var _this = this;
        var tableViewId = this.props.mailListTableProps.tableViewId;
        var shouldShowBehaviorMap = getMailMenuItemShouldShowMap();
        var actionSource = 'IconLV';
        var onDismiss = function () {
            _this.onDismissMoveToMenu();
        };
        return getMoveToPropertiesForContextMenu(tableViewId, onDismiss, actionSource, shouldShowBehaviorMap, [this.props.mailListItemDataProps.rowKey]);
    };
    MailListItemIconBar.prototype.render = function () {
        var _a = this.props, mailListItemDataProps = _a.mailListItemDataProps, mailListTableProps = _a.mailListTableProps;
        var backgroundColorClass = getBackgroundColorClass(mailListItemDataProps, mailListTableProps, this.isChecked);
        return (React.createElement(IconBar, { hoverActionIcons: this.showHoverActions ? this.getHoverActionIcons() : null, propertyIcons: this.getPropertyIconProps(), backgroundColorClassName: backgroundColorClass, iconClass: styles.icon, propertyIconClass: classNames(styles.propertyIcon, this.showHoverActions && styles.propertyIconHide), hoverIconClass: styles.hoverActionIcon, iconBarContainerClass: styles.iconBarContainer }));
    };
    tslib_1.__decorate([
        computed
    ], MailListItemIconBar.prototype, "isChecked", null);
    tslib_1.__decorate([
        computed
    ], MailListItemIconBar.prototype, "showHoverActions", null);
    MailListItemIconBar = tslib_1.__decorate([
        observer
    ], MailListItemIconBar);
    return MailListItemIconBar;
}(React.Component));
export default MailListItemIconBar;
//# sourceMappingURL=MailListItemIconBar.js.map